import React, { useState } from 'react';
import { Button, Box } from '@mui/material';
import AddTeamMemberDialog from './AddMemberTeamDialog';

const AddMemberButton = ({ addMemberToTeam, users }) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = (payload) => {
    addMemberToTeam(payload);
    handleClose();
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Button
        variant="contained"
        color="primary"
        onClick={handleClickOpen}
        aria-hidden="true">
        Add New Member
      </Button>
      <AddTeamMemberDialog
        isOpen={open}
        users={users}
        onClose={handleClose}
        onSubmit={handleSubmit}
      />
    </Box>
  );
};

export default AddMemberButton;
